import {
  Button,
  Divider,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@material-ui/core";
import { EventBusyOutlined, Search, Tune } from "@material-ui/icons";
import { ptBR } from "date-fns/locale";
import { memo } from "react";
import { DateRangePicker, END_DATE, START_DATE } from "react-nice-dates";
import "react-nice-dates/build/style.css";
import Card from "../../../../components/cards/Card";
import { periods } from "../../constants";
import { receiptDates } from "../ContasReceberConstants";
import { useContasReceberService } from "../context/ContasReceberContext";
import "../styles/style.css";
import GroupMenuButton from "./GroupMenuButton";
import SelectFilter from "./SelectFilter";
import SituationChip from "./SituationChip";
import SituationsDrawer from "./SituationsDrawer";
import SortMenuButton from "./SortMenuButton";

const Filter = () => {
  const {
    refetch,
    filters,
    cachedCompanies,
    setSelectedCompany,
    loadingCompanies,
    setPeriod,
    filterPeriod,
    setCustomDatePeriod,
    setDateFilter,
    setName,
    setDrawerOpen,
    cachedSituations,
    quickSituations,
  } = useContasReceberService();

  const checkedSituations = [
    ...cachedSituations.filter((situation) =>
      filters.status?.includes(situation.id)
    ),
    ...quickSituations.filter((situation) =>
      filters.quickStatus?.includes(situation.id)
    ),
  ];

  return (
    <Grid item xs>
      <Grid
        item
        container
        component={Card}
        direction={"column"}
        style={{
          gap: 24,
          borderLeft: "6px solid #d6e5ff",
          boxSizing: "border-box",
        }}
      >
        <SituationsDrawer />

        <Grid item container xs style={{ gap: 16 }}>
          <Grid item xs>
            <SelectFilter
              filterMatch={filters.multicompany}
              filterOptions={cachedCompanies}
              setFilter={setSelectedCompany}
              label="Empresa"
              loading={loadingCompanies}
            />
          </Grid>

          <Grid item xs>
            <TextField
              InputLabelProps={{ shrink: true }}
              label="Cliente"
              placeholder="Digite a razão social ou CNPJ do Cliente"
              onChange={(event) => setName(event.target.value)}
            />
          </Grid>
        </Grid>
        <Grid item container xs style={{ gap: 8 }}>
          <Grid item xs={2}>
            <SelectFilter
              filterMatch={filters.dateFilter}
              filterOptions={receiptDates}
              setFilter={setDateFilter}
              label="Data de"
            />
          </Grid>
          <Grid item xs={2}>
            <SelectFilter
              label="Periodo de busca"
              filterMatch={filters.period}
              filterOptions={periods}
              setFilter={setPeriod}
            />
          </Grid>
          {filters.period === "custom" && (
            <Grid item xs={4}>
              <DateRangePicker
                startDate={filterPeriod.startDate}
                endDate={filterPeriod.endDate}
                onStartDateChange={(newDate) => {
                  setCustomDatePeriod({
                    startDate: newDate,
                  });
                }}
                onEndDateChange={(newDate) => {
                  setCustomDatePeriod({
                    endDate: newDate,
                  });
                }}
                minimumLength={0}
                format="dd/MM/yyyy"
                weekdayFormat="EEEEE"
                locale={ptBR}
                maximumLength={365}
              >
                {({ startDateInputProps, endDateInputProps, focus }) => (
                  <div
                    className="date-range"
                    style={{
                      display: "flex",
                      gap: 16,
                    }}
                  >
                    <TextField
                      size="small"
                      label="Data inicial"
                      className={
                        "input" + (focus === START_DATE ? " -focused" : "")
                      }
                      {...startDateInputProps}
                      placeholder="Ex: 01/12/2022"
                    />
                    <TextField
                      size="small"
                      label="Data final"
                      className={
                        "input" + (focus === END_DATE ? " -focused" : "")
                      }
                      {...endDateInputProps}
                      placeholder="Ex: 31/12/2022"
                    />
                    <Tooltip title="Limpar filtro de datas">
                      <IconButton
                        size="small"
                        onClick={() =>
                          setCustomDatePeriod({
                            startDate: undefined,
                            endDate: undefined,
                          })
                        }
                        style={{
                          color: "red",
                        }}
                      >
                        <EventBusyOutlined />
                      </IconButton>
                    </Tooltip>
                  </div>
                )}
              </DateRangePicker>
            </Grid>
          )}
          <Grid item xs />
        </Grid>
        {!!checkedSituations.length && (
          <Grid
            item
            xs
            style={{
              alignItems: "center",
              display: "flex",
              flexWrap: "wrap",
              gap: 8,
            }}
          >
            <Typography style={{ fontWeight: "bold" }} variant="subtitle2">
              Situações:
            </Typography>
            {checkedSituations.map((item) => {
              return <SituationChip situation={item} key={item.id} />;
            })}
          </Grid>
        )}

        <Divider />
        <Grid item xs container direction="row" spacing={2}>
          <Grid item xs>
            <Button
              size="small"
              color="primary"
              variant="contained"
              startIcon={<Search />}
              onClick={async () => {
                await refetch();
              }}
            >
              Gerar relatório
            </Button>
          </Grid>
          <Grid item>
            <SortMenuButton label={"Ordenando"} />
          </Grid>
          <Grid item>
            <GroupMenuButton label={"Agrupando"} />
          </Grid>
          <Grid item>
            <Button
              startIcon={<Tune />}
              color="primary"
              variant="outlined"
              size="small"
              onClick={() => setDrawerOpen(true)}
            >
              Situação dos títulos
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default memo(Filter);
